/* eslint-disable promise/always-return */
/* eslint-disable promise/catch-or-return */
import 'underscore';
import { touchWebClient } from 'tradera-utils/http';

var _cache = {};
var _title = '';

function existsInCache(categoryId) {
    return !_.isUndefined(_cache[categoryId]);
}

const clearCache = title => {
    if ((!_title && !title) || _title === title) {
        return;
    }
    _cache = {};
};

const loadTopCategories = title => {
    return new Promise((resolve, reject) => {
        clearCache(title);
        _title = title;

        if (_cache.topCategories) {
            resolve(_cache.topCategories);
        } else {
            touchWebClient
                .post('/selling/toplevelcategorysuggestions', {
                    title: title || ''
                })
                .then(function(result) {
                    _cache.topCategories = result.data;
                    resolve(result.data);
                })
                .catch(reject);
        }
    });
};

const loadChildCategories = (title, categoryId, level) => {
    return new Promise((resolve, reject) => {
        _title = title;
        if (!categoryId) {
            reject();
            return;
        }

        if (existsInCache(categoryId)) {
            resolve(_cache[categoryId]);
        } else {
            const levelToSearch = level + 1;
            const params = {
                title: title || '',
                categoryId: categoryId,
                levelToSearch
            };
            touchWebClient
                .post('/selling/categorysuggestions', params, {
                    cancelTokenId: `cancel-category-level-search-${levelToSearch}`
                })
                .then(function(result) {
                    _cache[categoryId] = result.data;
                    resolve(result.data);
                })
                .catch(reject);
        }
    });
};

const prefetchChildren = (title, categories, level) => {
    _title = title;
    var allCategories = categories.categories.concat(categories.suggestions);
    var ids = _.chain(allCategories)
        .filter(function(c) {
            return !existsInCache(c.categoryId);
        })
        .map(function(c) {
            return c.categoryId;
        })
        .value();

    if (_.isEmpty(ids)) {
        return;
    }

    var params = {
        title: _title || '',
        categoryIds: ids,
        levelToSearch: level + 1
    };

    touchWebClient
        .post('/selling/childcategorysuggestions', params)
        // eslint-disable-next-line promise/always-return
        .then(function(result) {
            _.each(result.data, function(categoryInfo) {
                _cache[categoryInfo.categoryId] = categoryInfo;
            });
        });
};

export default {
    clearCache,
    loadTopCategories,
    loadChildCategories,
    prefetchChildren
};
